export default __webpack_public_path__ + "static/media/close-pwa.6c9a4ba7.svg";